import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { WebStorageService } from '../services/web-storage/web-storage.service';
import { STORAGE_SESSION_KEY } from './constants';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ApiSessionKeyGuard implements CanActivate {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _apiService: ApiService,
    private _storage: WebStorageService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    const key = this._storage.session.get(STORAGE_SESSION_KEY);

    const params: any = {};
    if (key) {
      params.key = key;
    }

    return this._apiService
      .get('api.session', 'current', null, {
        params,
      })
      .pipe(
        tap((res) => this._storage.session.save(STORAGE_SESSION_KEY, res.key)),
        map((res) => true),
      );
  }
}
